export enum ContactOption {
    EMAIL = 'Email',
    PHONE = 'Phone',
    MEETING = 'Meeting',
    SMS = 'SMS',
    OTHER = 'Other'
}